import { render, staticRenderFns } from "./CriteriaRadioCard.vue?vue&type=template&id=1d2f0994&scoped=true"
import script from "./CriteriaRadioCard.vue?vue&type=script&lang=js"
export * from "./CriteriaRadioCard.vue?vue&type=script&lang=js"
import style0 from "./CriteriaRadioCard.vue?vue&type=style&index=0&id=1d2f0994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f0994",
  null
  
)

export default component.exports